import React, { Component } from "react";
import { Popover, Button, Spin } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { formatePrice } from "../../utils/general";
import { getSettlementDetailsAPI } from "../../Graphs/Report/subAdminSettlementAPI";
import { alertError } from "../../utils/alert";

class PayableBreakdownModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      settlement: props.settlement || null,
      isVisible: props.visible !== undefined ? props.visible : false,
    };
  }

  componentDidMount() {
    if (this.props.visible && this.props.settlementId && !this.props.settlement) {
      this.fetchDetails(this.props.settlementId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== undefined && this.props.visible !== prevProps.visible) {
      this.setState({ isVisible: this.props.visible });
      if (this.props.visible && this.props.settlementId && !this.props.settlement) {
        this.fetchDetails(this.props.settlementId);
      }
    }
    if (this.props.settlement && this.props.settlement !== prevProps.settlement) {
      this.setState({ settlement: this.props.settlement });
    }
  }

  fetchDetails = async (settlementId) => {
    try {
      this.setState({ isLoading: true });
      const { authToken } = this.props;
      const res = await getSettlementDetailsAPI(authToken, settlementId);
      if (res && res.status === 200 && res.data) {
        this.setState({ settlement: res.data });
      } else {
        throw new Error((res && res.message) || "Failed to load breakdown details");
      }
    } catch (err) {
      alertError("BREAKDOWN DETAILS", err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleVisibleChange = (visible) => {
    this.setState({ isVisible: visible });
    if (visible) {
      const settlementId = this.props.settlementId;
      const settlement = this.props.settlement || this.state.settlement;
      if (settlementId && (!settlement || !settlement.items)) {
        this.fetchDetails(settlementId);
      }
    }
    if (!visible && this.props.onClose) {
      this.props.onClose();
    }
    if (this.props.onVisibleChange) {
      this.props.onVisibleChange(visible);
    }
  };

  handleClose = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    this.setState({ isVisible: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
    if (this.props.onVisibleChange) {
      this.props.onVisibleChange(false);
    }
  };

  render() {
    const { kpis, titleContext, placement } = this.props;
    const { isLoading, isVisible } = this.state;
    const visible = this.props.visible !== undefined ? this.props.visible : isVisible;
    const settlement = this.props.settlement || this.state.settlement;

    let adminCount = 0;
    let adminCost = 0;
    let mintApiCount = 0;
    let mintApiCost = 0;
    let likeApiCount = 0;
    let likeApiCost = 0;
    let khalesApiCount = 0;
    let khalesApiCost = 0;
    let apiTotalCount = 0;
    let apiTotalCost = 0;
    let totalPayable = 0;
    let totalCards = 0;
    let totalRetail = 0;
    let cityLabel = "";
    let periodLabel = "";
    let isAggregate = false;

    if (settlement) {
      adminCount = Number(settlement.borrowed_cards_count || 0);
      adminCost = Number(settlement.borrowed_cards_cost_total || 0);
      totalPayable = Number(settlement.net_payable_to_admin || 0);
      totalCards = Number(settlement.total_cards_count || 0);
      totalRetail = Number(settlement.total_retail_sales || 0);
      cityLabel =
        (settlement.user_city && settlement.user_city.name) ||
        settlement.city ||
        "";
      periodLabel = settlement.period_label || settlement.period_date || "";

      const items = settlement.items || [];
      items.forEach((item) => {
        if (item.source === "mint_api") {
          mintApiCount += Number(item.quantity || 0);
          mintApiCost += Number(item.total_cost || 0);
        } else if (item.source === "like_api") {
          likeApiCount += Number(item.quantity || 0);
          likeApiCost += Number(item.total_cost || 0);
        } else if (item.source === "khales_api") {
          khalesApiCount += Number(item.quantity || 0);
          khalesApiCost += Number(item.total_cost || 0);
        }
      });

      apiTotalCount = mintApiCount + likeApiCount + khalesApiCount;
      apiTotalCost = mintApiCost + likeApiCost + khalesApiCost;

      if (apiTotalCount === 0 && Number(settlement.api_cards_count || 0) > 0) {
        apiTotalCount = Number(settlement.api_cards_count || 0);
        apiTotalCost = Number(settlement.api_cards_cost_total || 0);
        mintApiCount = apiTotalCount;
        mintApiCost = apiTotalCost;
      }
    } else if (kpis) {
      isAggregate = true;
      adminCount = Number(kpis.total_borrowed_cards_count || 0);
      adminCost = Number(kpis.total_borrowed_cards_cost || 0);
      apiTotalCount = Number(kpis.total_api_cards_count || 0);
      apiTotalCost = Number(kpis.total_api_cards_cost || 0);
      totalPayable = Number(kpis.total_net_payable || 0);
      totalCards = Number(kpis.total_cards_count || 0);
      totalRetail = Number(kpis.total_retail_sales || 0);
      periodLabel = titleContext || "Filtered Period Summary";
    }

    const payableCardsCount = adminCount + apiTotalCount;

    const popupContent = (
      <div className="payable-popover-content">
        {isLoading ? (
          <div className="payable-popover-loading">
            <Spin size="small" />
          </div>
        ) : (
          <div>
            {/* Header: Title and Close button */}
            <div className="payable-popover-header">
              <div className="popover-title-row">
                <span className="popover-title">Amount payable breakdown</span>
                <Button
                  type="text"
                  size="small"
                  icon={<CloseOutlined />}
                  className="popover-close-btn"
                  onClick={this.handleClose}
                  aria-label="Close"
                />
              </div>
              {(cityLabel || periodLabel) && (
                <div className="popover-subtitle">
                  {cityLabel && <span>{cityLabel}</span>}
                  {cityLabel && periodLabel && <span className="subtitle-dot">•</span>}
                  {periodLabel && <span>{periodLabel}</span>}
                </div>
              )}
            </div>

            {/* Small Material Table Breakdown */}
            <table className="payable-popover-table">
              <thead>
                <tr>
                  <th className="col-source">Source</th>
                  <th className="col-qty">Quantity</th>
                  <th className="col-cost">Total cost</th>
                </tr>
              </thead>
              <tbody>
                {/* Row 1: Admin */}
                <tr>
                  <td className="col-source">Admin</td>
                  <td className="col-qty">{adminCount.toLocaleString()} cards</td>
                  <td className="col-cost">{formatePrice(adminCost)} LYD</td>
                </tr>

                {/* Row 2: Mint API */}
                <tr>
                  <td className="col-source">Mint API</td>
                  <td className="col-qty">
                    {isAggregate
                      ? `${apiTotalCount.toLocaleString()} cards`
                      : `${mintApiCount.toLocaleString()} cards`}
                  </td>
                  <td className="col-cost">
                    {formatePrice(isAggregate ? apiTotalCost : mintApiCost)} LYD
                  </td>
                </tr>

                {/* Row 3: Like API */}
                {!isAggregate && (
                  <tr>
                    <td className="col-source">Like API</td>
                    <td className="col-qty">{likeApiCount.toLocaleString()} cards</td>
                    <td className="col-cost">{formatePrice(likeApiCost)} LYD</td>
                  </tr>
                )}

                {/* Row 4: Khales API */}
                {!isAggregate && (
                  <tr>
                    <td className="col-source">Khales API</td>
                    <td className="col-qty">{khalesApiCount.toLocaleString()} cards</td>
                    <td className="col-cost">{formatePrice(khalesApiCost)} LYD</td>
                  </tr>
                )}

                {/* Total Row */}
                <tr className="row-total">
                  <td className="col-source">Total payable</td>
                  <td className="col-qty">{payableCardsCount.toLocaleString()} cards</td>
                  <td className="col-cost">{formatePrice(totalPayable)} LYD</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    );

    const triggerNode = this.props.children || (
      <span className="payable-popover-anchor" style={{ display: "inline-block" }} />
    );

    return (
      <Popover
        overlayClassName="payable-breakdown-popover"
        placement={placement || "bottomRight"}
        trigger="click"
        visible={visible}
        onVisibleChange={this.handleVisibleChange}
        content={popupContent}
        destroyTooltipOnHide
      >
        {triggerNode}
      </Popover>
    );
  }
}

export { PayableBreakdownModal, PayableBreakdownModal as PayableBreakdownPopover };
export default PayableBreakdownModal;
